import Reflux from 'reflux'
import LookupActions from '../actions/LookupActions'

export var LookupasteriskRefreshStore = Reflux.createStore(
{
    init:function()
    {
        this.listenTo(LookupActions.lookupasteriskRefresh,'onLookupAsteriskRefresh');
    },
    onLookupAsteriskRefresh(formId,innerId,filter)
    {
        this.trigger(formId,innerId,filter);
    }
});

export var LookupHostKeydownStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(LookupActions.lookupHostKeydown,'onLookupHostKeydown');
		//this.listenTo(LookupActions.lookupReturnMutiField,'onLookupReturnMutiField')
	},
    onLookupHostKeydown(lookupKey,keyCode)
    {
		this.trigger(lookupKey,keyCode);
    }
    /*,
    onLookupReturnMutiField(toDataField,value)
    {
    	this.trigger(toDataField,value);
    }*/
});

export var LookupReturnMutiEditorStore = Reflux.createStore({

    init:function()
    {
        this.listenTo(LookupActions.lookupReturnMutiEditor,'onLookupReturnMutiEditor');
    },
    onLookupReturnMutiEditor(editorName,value)
    {
        this.trigger(editorName,value);
    }

});

export var LookupDropDownCloseStore = Reflux.createStore({

    init:function()
    {
        this.listenTo(LookupActions.popDropDownClose,'onLookupPopDropDownClose');
    },
    onLookupPopDropDownClose(formId,innerId)
    {
         this.trigger(formId,innerId);
    }
});

export var LookupAutoQueryStore = Reflux.createStore({

    init:function()
    {
        this.listenTo(LookupActions.lookupAutoQuery,'onLookupAutoQuery');
    },
    onLookupAutoQuery(key,args)
    {
        this.trigger(key,args);
    }

});


// WEBPACK FOOTER //
// ./src/stores/LookupStores.js